var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordOptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50044 12.3333H0.666992L3.74288 3.66663H5.86511L8.92757 12.3333H7.0001L6.2815 10.1047H3.21904L2.50044 12.3333ZM4.79728 5.32377H4.71669L3.59513 8.82853H5.91884L4.79728 5.32377Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9633 12.3035C14.4425 12.3035 15.3337 11.244 15.3337 9.48805V8.63091C15.3337 6.87496 14.4485 5.82139 12.987 5.82139C12.084 5.82139 11.3711 6.24401 11.1632 6.90472H11.086V3.66663H9.51761V12.2202H11.0622V11.2559H11.1394C11.3949 11.9047 12.084 12.3035 12.9633 12.3035ZM12.4405 11.0535C11.6385 11.0535 11.086 10.4226 11.086 9.49401V8.70829C11.086 7.70234 11.5969 7.07139 12.4227 7.07139C13.2544 7.07139 13.7296 7.70234 13.7296 8.79758V9.3452C13.7296 10.4285 13.2603 11.0535 12.4405 11.0535Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordOptionIcon);
export default __webpack_public_path__ + "static/media/wordOptionIcon.7b30cedacad311f8c477b7d2353d9059.svg";
export { ForwardRef as ReactComponent };